import React from "react";


import {
    ReactSVG
} from "react-svg";


type SvgIconComponentProps = {
    iconSource: string;
    className?: string;
};


export const SvgIconComponent:React.FC<SvgIconComponentProps> = ({
    iconSource, className
}) => {

    if (!iconSource) {
        return null;
    }

    return (
        <ReactSVG src={iconSource} wrapper={'span'} className={className} />
    );
};


export default SvgIconComponent;
